import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled, alpha } from '@mui/material';
import { PROMETHEAN_TEXT, PROMETHEAN_NEUTRAL_DARK_PLUM, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_TEXT_HEADER, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_DARK_PURPLE, PROMETHEAN_LIGHT_PURPLE, PROMETHEAN_MID_PURPLE, PROMETHEAN_BLUE } from '../styles/colors/colors';
import { prometheanFont } from '../styles/font/font';
export var LINE_TOP_OFFSET_PRIMARY = 8.5;
export var LINE_TOP_OFFSET_CHILD = 12;
export var TREE_NODE_HEIGHT = 44;
var NAV_FONT = {
  fontSize: 14,
  lineHeight: '18px',
  letterSpacing: '0.01em',
  fontFamily: prometheanFont,
  color: PROMETHEAN_TEXT_HEADER
};
export var EmbersNavDot = styled('div')(function () {
  return {
    label: 'EmbersNavDot',
    flexGrow: 0,
    flexShrink: 0,
    width: 5,
    height: 5,
    borderRadius: '50%',
    boxSizing: 'border-box',
    border: "1px solid ".concat(PROMETHEAN_NEUTRAL_DARK_PLUM),
    backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
    marginRight: 14,
    pointerEvents: 'none',
    position: 'relative',
    zIndex: 2,
    '&.EmbersNav-bottom-dot': {
      position: 'absolute',
      top: 'var(--tree-view-finalDotTop)',
      left: 'var(--tree-view-finalDotLeft)'
    }
  };
});
export var StyledNavItemRoot = styled('div')(function (_ref) {
  var _ref$styles = _ref.styles,
    isMobile = _ref$styles.isMobile,
    indent = _ref$styles.indent,
    lineHeight = _ref$styles.lineHeight;
  return {
    boxSizing: 'content-box',
    position: 'relative',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    userSelect: 'none',
    cursor: 'pointer',
    height: '40px',
    padding: '0 16px 0 18px',
    borderRadius: 4,
    marginBottom: 4,
    maxWidth: "".concat(Math.min(256 - indent - 16, 222), "px"),
    width: isMobile ? 'calc(100% - 22px)' : 'auto',
    paddingLeft: "".concat(indent, "px"),
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '[class*="icon-"]': {
      color: PROMETHEAN_TEXT,
      fontSize: 20
    },
    '.MuiListItemIcon-root': {
      minWidth: 'inherit',
      '[class*="icon-"]': {
        fontSize: 16,
        margin: '0 8px 0 -1px'
      }
    },
    img: {
      width: 14,
      height: 14,
      marginRight: 8
    },
    '.EmbersNav-label-text .MuiListItemText-primary': _objectSpread(_objectSpread({}, NAV_FONT), {}, {
      wordBreak: 'break-word',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: '2',
      overflow: 'hidden',
      margin: 0
    }),
    '&:hover': {
      backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.4),
      boxShadow: "0 0 0 1px ".concat(PROMETHEAN_MID_PURPLE, " inset"),
      '&:active': {
        backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.4),
        '& .MuiTreeItem-label': {
          fontWeight: 400
        }
      }
    },
    '&:active': {
      backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.4)
    },
    '&:focus-visible': {
      backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.4),
      boxShadow: "0 0 0 2px ".concat(PROMETHEAN_BLUE, " inset")
    },
    '&.Embers-selected': {
      backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
      boxShadow: "0 0 0 1px ".concat(PROMETHEAN_PURPLE_GRAPE, " inset"),
      ':focus-visible': {
        backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
        outline: "2px solid ".concat(PROMETHEAN_BLUE),
        outlineOffset: 1,
        margin: '3px 3px 7px 3px',
        paddingLeft: "".concat(indent - 3, "px"),
        paddingRight: 13,
        height: 34,
        '&.EmbersNav-primary': {
          paddingLeft: 15
        }
      },
      '& .MuiListItemText-primary': {
        fontWeight: 600,
        color: PROMETHEAN_PURPLE_GRAPE
      },
      '&:active': {
        backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.4),
        '& .MuiListItemText-primary': {
          fontWeight: 600
        }
      },
      '.MuiListItemIcon-root [class*="icon-"]': {
        color: PROMETHEAN_PURPLE_GRAPE
      },
      '&:hover': {
        backgroundColor: alpha(PROMETHEAN_LIGHT_PURPLE, 0.4),
        boxShadow: "0 0 0 1px ".concat(PROMETHEAN_DARK_PURPLE, " inset"),
        '& .MuiListItemText-primary': {
          color: PROMETHEAN_DARK_PURPLE
        },
        '&:active': {
          backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.4),
          '& .MuiListItemText-primary': {
            fontWeight: 600
          }
        },
        '.MuiListItemIcon-root [class*="icon-"]': {
          color: PROMETHEAN_DARK_PURPLE
        }
      }
    },
    '&.Embers-disabled': {
      cursor: 'auto',
      '&:hover': {
        backgroundColor: 'inherit',
        color: 'inherit'
      }
    },
    '&.EmbersNav-expanded:before': {
      height: "".concat(lineHeight, "px")
    },
    /** Drawing out the vertical line */
    '&:before': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      height: 0,
      marginLeft: 1,
      borderLeft: "1px solid ".concat(PROMETHEAN_NEUTRAL_DARK_PLUM),
      pointerEvents: 'none'
    },
    '&:not(.EmbersNav-primary):before': {
      transform: "translateY(50%) translate(25px, ".concat(LINE_TOP_OFFSET_CHILD, "px)")
    },
    '&.EmbersNav-primary:before': {
      transform: "translateY(50%) translate(5px, ".concat(LINE_TOP_OFFSET_PRIMARY, "px)")
    },
    '&.EmbersNav-hasChildren': {
      paddingRight: 8,
      maxWidth: 230,
      '.MuiListItemText-root': {
        marginRight: 5,
        flex: 1
      }
    },
    '&.EmbersNav-hasChildren.Embers-selected:focus-visible': {
      paddingRight: 5,
      maxWidth: 256 - indent - 8
    },
    '&.EmbersNav-primary.EmbersNav-hasChildren.Embers-selected:focus-visible': {
      maxWidth: 230,
      paddingRight: 5
    },
    '.EmbersNav-item-postfixIcon': {
      width: 40,
      height: 40,
      borderRadius: '50%',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '> span:focus-visible': {
        outline: "2px solid ".concat(PROMETHEAN_BLUE)
      }
    }
  };
});